import cx from 'clsx';

import { Skeleton } from '@shared/components/core';

import styles from './PageSkeleton.module.scss';

const SidebarSkeleton = () => (
	<div
		className={cx(
			'border-grey2 d-flex flex-column bg-white height100',
			styles.sidebar,
		)}
	>
		{/* Top buttons */}
		<div className="d-flex gap4 border-grey2 border-bottom1 py3 px4">
			<Skeleton height={42} />
			<Skeleton height={42} />
		</div>

		{/* Menu items */}
		<div className="d-flex flex-column gap4 mt1 p4">
			{new Array(6).fill(0).map((_, i) => (
				<div
					key={_ + i}
					className={cx(styles.column1, 'd-flex gap2 items-center')}
				>
					<Skeleton height={32} width={32} />
					<Skeleton height={22} width={56} />
				</div>
			))}
		</div>
	</div>
);

const ContentSkeleton = () => (
	<div
		id="page-skeleton"
		className={cx(
			'flex1 p4 d-flex flex-column gap6 height100 width100',
			styles.listContainer,
		)}
	>
		<div className="border1 border-grey2 height100 bg-white width100 border-radius2">
			<Skeleton height={50} />
			{/* Table rows */}
			<div className="d-flex flex-column gap4 p4">
				{new Array(6).fill(0).map((_, i) => (
					<div key={_ + i} className="d-flex gap4 justify-between">
						<div className={cx(styles.column1, 'd-flex gap2 items-center')}>
							<Skeleton height={32} width={32} />
							<Skeleton height={22} width={56} />
						</div>
						<div className={styles.column2}>
							<Skeleton height={22} width={90} />
						</div>
						<div className={styles.column3}>
							<Skeleton height={48} width={48} />
						</div>
					</div>
				))}
			</div>
		</div>
	</div>
);

const PageSkeleton = () => (
	<div className={cx('d-flex width100', styles.content)}>
		<SidebarSkeleton />
		<ContentSkeleton />
	</div>
);

export default PageSkeleton;
